<template>
  <div class="primary-not-found-error">
    <div class="error-image-wrapper">
      <img
          class="error-image"
          alt="404 - Not Found"
          :src="require('../../../../static/errors/404/not-found-primary.png')"
      >
    </div>

    <div class="error-title-wrapper">
      <h2 class="error-title">
        {{ title }}
      </h2>
    </div>

    <div class="error-message-wrapper">
      <h4 class="error-message">
        {{ message }}
      </h4>
    </div>

    <div class="error-redirect-button-wrapper">
      <b-button
          size="lg"
          variant="primary"
          class="error-redirect-button"
          @click="redirectToHome"
      >
        <span class="redirect-button-text">
          {{ redirectButtonText }}
        </span>
      </b-button>
    </div>
  </div>
</template>

<script>
    import './PrimaryNotFoundError.scss';
    import './PrimaryNotFoundError.sm.scss';

    const DEFAULT_TITLE = 'Page cannot be found';
    const DEFAULT_MESSAGE = `The page you are looking for may have been removed,
    had its name changed, or is temporarily unavailable.`;
    const DEFAULT_REDIRECT_BUTTON_TEXT = 'Visit Home Page';


    export default {
        name: 'PrimaryNotFoundError',

        props: {
            title: {
                type: String,
                default: DEFAULT_TITLE,
            },
            message: {
                type: String,
                default: DEFAULT_MESSAGE,
            },
            redirectButtonText: {
                type: String,
                default: DEFAULT_REDIRECT_BUTTON_TEXT,
            },
            redirectSrc: {
                type: String,
                default: '/',
            }
        },

        methods: {
            redirectToHome() {
                window.location.href = this.redirectSrc;
            }
        }
    };
</script>
